import {Component, ElementRef, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {ActivatedRoute, ActivationEnd, Router, UrlSegment} from '@angular/router';
import {filter} from 'rxjs/operators';
import {SignOut} from '../../../authentication/store/authentication-actions';
import {AppState} from '../../../app.store';
import {UserInfo} from 'firebase';
import {SearchUser} from '../../../user/state/user.actions';
import {SearchService} from '../../../search/service/search.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  private toggleButton: any;
  private sidebarVisible: boolean;
  public search: string;
  public user$: Observable<UserInfo>;
  from: string;

  constructor(public location: Location, private element: ElementRef, private store: Store<AppState>,
              private activeRoute: ActivatedRoute,
              private searchService: SearchService,
              private router: Router) {
    this.user$ = store.select(state => {
      return state.auth.user;
    });
    this.sidebarVisible = false;
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event ) => event instanceof ActivationEnd)
    ).subscribe((event) => {
      console.log(event);
      this.from = '/' + ( event as ActivationEnd).snapshot.url.map(u => u.path).join('/');
      console.log('from', this.from);
    });
    this.activeRoute.url.subscribe((urlSegments: UrlSegment[]) => {
      console.log('url segmentss');
      console.log(urlSegments);
    });
    const navbar: HTMLElement = this.element.nativeElement;
    // navbar.classList.add('navbar-transparent');
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const html = document.getElementsByTagName('html')[0];
    setTimeout(() => {
      toggleButton.classList.add('toggled');
    }, 500);
    html.classList.add('nav-open');

    this.sidebarVisible = true;
  }

  sidebarClose() {
    const html = document.getElementsByTagName('html')[0];
    // console.log(html);
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    html.classList.remove('nav-open');
  }

  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  isHome() {
    const title = this.location.prepareExternalUrl(this.location.path());

    return title === '/home';
  }

  signout() {
    this.store.dispatch(new SignOut());
  }

  searchKeyDown($event: KeyboardEvent) {

    if ( $event.key === 'Enter') {
      console.log(`enter pressed ${this.search}`);
      this.store.dispatch(new SearchUser(this.search));
      // const observable = this.searchService.search(this.search);
      // console.log('observable', observable);
      // observable.subscribe(r => console.log(r));
    }
  }
}
